export default __webpack_public_path__ + "media/packs/images/icons/book-open-e567d8602a02af562aa9972e2b493871.svg";